import { useNavigate } from 'react-router-dom';
import { Button, Space } from 'antd';
import { ArrowLeftOutlined, HistoryOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/PageHeader';
import { GenerarCobrosForm } from './components/GenerarCobrosForm';
import { useHasPermission } from '../../auth/useHasPermission';
import { EmptyState } from '../../components/EmptyState';
import { useT } from '../../locales';
import { Permission } from '@aid/shared';

export function CobrosGenerarPage() {
  const t = useT();
  const navigate = useNavigate();
  const hasPermission = useHasPermission(Permission.COBROS_GENERAR);
  const canRead = useHasPermission(Permission.COBROS_READ);

  if (!hasPermission) {
    return <EmptyState title={t('pages.cobros.noPermissionGenerar')} />;
  }

  return (
    <div>
      <PageHeader
        title={t('pages.cobros.generar')}
        subtitle={t('pages.cobros.generarSubtitle')}
        actions={
          <Space wrap>
            {canRead && (
              <Button
                icon={<HistoryOutlined />}
                onClick={() => navigate('/facturas/historial-generacion')}
              >
                {t('nav.historialGeneracion')}
              </Button>
            )}
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/facturas')}>
              {t('pages.cobros.backToList')}
            </Button>
          </Space>
        }
      />
      <GenerarCobrosForm />
    </div>
  );
}
